"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var prop_types_1 = __importDefault(require("prop-types"));
var BubblyDefault_1 = __importDefault(require("@acl-services/wasabicons/lib/BubblyDefault"));
var notification_card_1 = __importDefault(require("@paprika/notification-card"));
var useI18n_1 = __importDefault(require("@paprika/l10n/lib/useI18n"));
var ArrowRightB_1 = __importDefault(require("@acl-services/wasabicons/lib/ArrowRightB"));
var ArrowDownB_1 = __importDefault(require("@acl-services/wasabicons/lib/ArrowDownB"));
var ArrowLeftB_1 = __importDefault(require("@acl-services/wasabicons/lib/ArrowLeftB"));
var ArrowUpB_1 = __importDefault(require("@acl-services/wasabicons/lib/ArrowUpB"));
var shortcutHelpers_1 = require("../shortcutHelpers");
var sc = __importStar(require("./Shortcuts.styles"));
function Shortcuts(_a) {
    var section = _a.section;
    var i18n = useI18n_1.default();
    function renderKeyValue(key) {
        if (key.length === 1)
            return key.toUpperCase();
        switch (key) {
            case 'metaKey':
                return '⌘';
            case 'arrowup':
                return react_1.default.createElement(ArrowUpB_1.default, null);
            case 'arrowdown':
                return react_1.default.createElement(ArrowDownB_1.default, null);
            case 'arrowleft':
                return react_1.default.createElement(ArrowLeftB_1.default, null);
            case 'arrowright':
                return react_1.default.createElement(ArrowRightB_1.default, null);
            case shortcutHelpers_1.DELIMITERS.COMMA:
                return react_1.default.createElement(sc.Comma, null, " , ");
            case shortcutHelpers_1.DELIMITERS.BACKSLASH:
                return react_1.default.createElement(sc.Slash, null, " / ");
            case shortcutHelpers_1.DELIMITERS.PLUS:
                return react_1.default.createElement(sc.Add, null, " + ");
            default:
                return i18n.t("global_navigation.shortcut_keys." + key);
        }
    }
    function renderKey(key) {
        if (Object.keys(shortcutHelpers_1.DELIMITERS).includes(key)) {
            return renderKeyValue(key);
        }
        return react_1.default.createElement(sc.Shortcut, null, renderKeyValue(key));
    }
    function renderShortcut(keyCombo) {
        return keyCombo.map(function (key, index) { return (
        // eslint-disable-next-line react/no-array-index-key
        react_1.default.createElement("span", { key: key + "_" + index }, renderKey(key))); });
    }
    return (react_1.default.createElement(sc.ShortcutList, null, section !== shortcutHelpers_1.SECTIONS.BUBBLY ? (Object.keys(shortcutHelpers_1.shortcutKeys[section]).map(function (command) { return (react_1.default.createElement(sc.ShortcutContainer, { key: command },
        react_1.default.createElement(sc.ShortcutLabel, null, i18n.t(shortcutHelpers_1.commandLabels[command])),
        react_1.default.createElement(sc.ShortcutWrapper, null, renderShortcut(shortcutHelpers_1.shortcutKeys[section][command])))); })) : (react_1.default.createElement(notification_card_1.default, null,
        react_1.default.createElement(notification_card_1.default.Image, { align: notification_card_1.default.types.align.CENTER },
            react_1.default.createElement(BubblyDefault_1.default, { width: "100%", height: "100%" })),
        react_1.default.createElement(notification_card_1.default.Header, { level: 3 }, i18n.t('global_navigation.keyboard_commands.bubbly_header')),
        react_1.default.createElement(notification_card_1.default.Body
        // eslint-disable-next-line react/no-danger
        , { 
            // eslint-disable-next-line react/no-danger
            dangerouslySetInnerHTML: { __html: i18n.t('global_navigation.keyboard_commands.bubbly_description') } })))));
}
Shortcuts.propTypes = {
    section: prop_types_1.default.string.isRequired,
};
exports.default = Shortcuts;
//# sourceMappingURL=Shortcuts.js.map